window.CabaneLocal={async addItem(item){
const drawer=document.querySelector('cart-drawer'),sections=drawer?.getSectionsToRender?.().map(s=>s.id)||['cart-drawer','cart-icon-bubble'];
const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:item.id,quantity:item.quantity||1}],sections,sections_url:location.pathname})});
const result=await response.json();if(!response.ok||result.status)throw Error(result.description||'Cet article ne peut pas être ajouté.');
if(drawer?.renderContents){drawer.renderContents(result);}else{location.href=(window.Shopify?.routes?.root||'/')+'cart';}
document.dispatchEvent(new CustomEvent('cabane:cart-updated'));return result;
},show(){const d=document.querySelector('cart-drawer');if(d?.open)d.open();else location.href='/cart';}};
// Shared local navigation, loaded on every snapshot and product page.
document.addEventListener('DOMContentLoaded', () => {
  if (location.pathname !== '/') return;
  document.querySelectorAll('[id*="__bestsellers_refonte"], [id*="__promos_refonte"]').forEach(section => {
    const link = section.querySelector('.collection__title-top .collection__title-action');
    const products = section.querySelector('slider-component');
    if (!link || !products || section.querySelector('.local-collection-footer')) return;
    const footer = document.createElement('div');
    footer.className = 'local-collection-footer';
    footer.append(link);
    products.after(footer);
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('.lcg-header__benefits');
  const track = bar?.querySelector('.lcg-header__benefits-track');
  if (!track || bar.querySelector('.local-benefits-window')) return;
  const viewport = document.createElement('div');
  viewport.className = 'local-benefits-window';
  track.before(viewport);
  viewport.append(track);
  const nav = document.createElement('nav');
  nav.className = 'local-benefits-links';
  nav.setAttribute('aria-label', 'Aide et compte');
  nav.innerHTML = '<a href="/policies/refund-policy">Retours / échanges</a><a href="/pages/contact">Support</a><a href="/account">Mon compte</a>';
  bar.append(nav);
});

// Route assets are discovered in the document head and execute with defer.


